export default __webpack_public_path__ + "static/media/thumb-up.c1edcb7b.svg";